// Etiquetas en español de los códigos de la integración con máquinas.
// Fuente de los códigos: packages/schemas/src/ingesta_maquina.ts.

import type { EstadoMaquina, FuenteCapturaLinea } from 'schemas';

export const ETIQUETA_FUENTE: Record<FuenteCapturaLinea, string> = {
  manual: 'Manual',
  hibrida: 'Híbrida',
  maquina: 'Máquina',
};

export const ETIQUETA_ESTADO_MAQUINA: Record<EstadoMaquina, string> = {
  produciendo: 'Produciendo',
  parada: 'Parada',
  cambio: 'En cambio',
  sin_programa: 'Sin programa',
};

const ETIQUETA_CAMPO: Record<string, string> = {
  cantidad_procesada: 'Cantidad procesada',
  op_lote_oc_cliente: 'Lote / OP',
  sku_id: 'SKU',
  sku: 'SKU',
  numero_operarios: 'Operarios',
  hora_fin: 'Hora de fin del paro',
  causal_id: 'Causal del paro',
};

const ETIQUETA_RAZON: Record<string, string> = {
  conflicto_humano: 'Una persona ya ajustó este dato',
  solape_manual: 'Choca con una captura manual',
  fuera_de_ventana: 'Llegó fuera de la ventana de gracia',
  desorden_no_resoluble: 'Eventos en desorden',
  reloj_incoherente: 'Reloj de la máquina incoherente',
  sku_desconocido: 'SKU sin mapeo',
  causal_desconocida: 'Causal sin mapeo',
  paro_ref_desconocida: 'Paro de referencia desconocido',
};

function humanizar(codigo: string): string {
  const t = codigo.replace(/_/g, ' ');
  return t.charAt(0).toUpperCase() + t.slice(1);
}

export function etiquetaCampo(campo: string | null): string {
  if (!campo) return 'Registro';
  return ETIQUETA_CAMPO[campo] ?? humanizar(campo);
}

export function etiquetaRazon(razon: string): string {
  return ETIQUETA_RAZON[razon] ?? humanizar(razon);
}

/** Valor de un conflicto (desconocido por contrato) en texto legible. */
export function valorLegible(v: unknown): string {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'number') return v.toLocaleString('es-CO');
  if (typeof v === 'boolean') return v ? 'Sí' : 'No';
  if (typeof v === 'string') return v;
  try {
    return JSON.stringify(v);
  } catch {
    return String(v);
  }
}
